// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accboradlink {\n  margin-bottom: 10px;\n}\n.fixheaderCard {\n  position: fixed !important;\n  right: 10px;\n  bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
